import styled from '@emotion/styled';
import type { NumberInputProps } from '@hotjar/hotsauce';
import { Text, NumberInput, tokens } from '@hotjar/hotsauce';

const SuffixWrapper = styled.div`
  position: relative;
`;

const Suffix = styled(Text)<{ isInvalid?: boolean }>`
  position: absolute;
  top: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  right: ${tokens.spacer.x1};

  ${({ isInvalid }) =>
    isInvalid === true &&
    `
    right: ${tokens.spacer.x5};
    color: ${tokens.color.magenta_600};
  `}
`;

const StyledNumberInput = styled(NumberInput)<{ valueSize: number }>`
  ${({ valueSize }) => `
    input[type='number'] {
      padding-right: ${tokens.spacer.x3};
      box-sizing: content-box;
      width: calc(${Math.max(valueSize, 1)}ch);
    }
  `}
`;

export type SuffixedNumberInputProps = { suffix: string; valueSize: number } & Omit<
  NumberInputProps,
  'ref'
>;

export const SuffixedNumberInput = ({
  suffix,
  valueSize,
  isInvalid,
  ...numberInputProps
}: SuffixedNumberInputProps): JSX.Element => {
  return (
    <SuffixWrapper>
      <StyledNumberInput valueSize={valueSize} isInvalid={isInvalid} {...numberInputProps} />
      <Suffix isInvalid={isInvalid} textType="subtitle3" textColor="text_light">
        {suffix}
      </Suffix>
    </SuffixWrapper>
  );
};
